import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

export const applyEnhancement = store.effects.create((feature: Feature) =>
  feature.actions.applyEnhancement.request.observe().pipe(
    rxjsUtils.latestFrom(action => ({
      action: rxjs.of(action),
      editor: feature.selectors.editor.asObservable,
      enhancement: feature.selectors.enhancement.asObservable,
    })),
    rxjs.map(({ action, editor, enhancement }) => {
      if (!enhancement) {
        return feature.actions.applyEnhancement.cancellation
          .from(action)
          .create({
            reason: 'No enhancement to apply',
            request: action.data,
          })
      }
      if (!editor) {
        return feature.actions.applyEnhancement.error.from(action).create({
          error: new Error('Cannot figure out where to apply the new text'),
          request: action.data,
        })
      }
      editor.value = enhancement
      return feature.actions.applyEnhancement.success.from(action).create({
        request: action.data,
      })
    }),
  ),
)
